/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-symptom-history.reducer';

export const PatientSymptomHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientSymptomHistoryEntity = useAppSelector(state => state.patientSymptomHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientSymptomHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientSymptomHistory.detail.title">PatientSymptomHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientSymptomHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientSymptomHistoryEntity.id}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.patientSymptomHistory.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{patientSymptomHistoryEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.patientSymptomHistory.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{patientSymptomHistoryEntity.endDate}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.patientSymptomHistory.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{patientSymptomHistoryEntity.comments}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientSymptomHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientSymptomHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.patientSymptomHistory.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{patientSymptomHistoryEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientSymptomHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientSymptomHistoryEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.patientSymptomHistory.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{patientSymptomHistoryEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientSymptomHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientSymptomHistoryEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.patientSymptomHistory.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{patientSymptomHistoryEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientSymptomHistory.patient">Patient</Translate>
          </dt>
          <dd>{patientSymptomHistoryEntity.patient ? patientSymptomHistoryEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientSymptomHistory.symptom">Symptom</Translate>
          </dt>
          <dd>{patientSymptomHistoryEntity.symptom ? patientSymptomHistoryEntity.symptom.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientSymptomHistory.appointment">Appointment</Translate>
          </dt>
          <dd>{patientSymptomHistoryEntity.appointment ? patientSymptomHistoryEntity.appointment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientSymptomHistory.admission">Admission</Translate>
          </dt>
          <dd>{patientSymptomHistoryEntity.admission ? patientSymptomHistoryEntity.admission.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-symptom-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-symptom-history/${patientSymptomHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientSymptomHistoryDetail;
